import React from 'react';
import { connect } from 'react-redux';
import "../styles/patientLookup.css";
import * as actions from "../actions/index";
import PatientEnterDOBStep from "../components/PatientEnterDOBStep.jsx";
const I18n = require('react-redux-i18n').I18n;

const mapStateToProps = state => {
    return {
        dobField: state.questionnaire.dobField,
        enteredDOB: state.patients.enteredDOB,
        enteredDOBValid: state.patients.enteredDOBValid,
        selected: state.patients.selected
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        dobValueChanged: (dob) => dispatch(actions.changePatientDOBValue(dob)),
        showSearchFailedMessage: () => dispatch(actions.showMessageBoxBasedOnData(undefined, true, I18n.t('No results found'), I18n.t('Incorrect Date of Birth'), undefined, I18n.t('Close'))),
        validate: () => dispatch(actions.validate()),
        setEnteredDOBValid: (valid) => dispatch(actions.setEnteredDOBValid(valid)),
        goBack: () => {
            dispatch(actions.setCurrentStep(2));
            dispatch(actions.changePatientDOBValue(undefined))
        },
    }
};

const PatientEnterDOBStepController = connect(
    mapStateToProps,
    mapDispatchToProps
)(PatientEnterDOBStep);

export default PatientEnterDOBStepController;